import {
  ChevronDoubleDownIcon,
  ChevronDoubleUpIcon,
} from "@heroicons/react/24/solid";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import FullDetailsRegularization from "./fullDetailsRegularization";
import { getToken } from "../../services/Token";
import { useSetRegularizationUpdateMutation } from "../../api/regularizationApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLazyGetDashBoardReviewsQuery } from "../../api/allReviewsAPI";

const ReusableRegularization = ({ data, shouldShowApplyRejectButtons, isReviewCard }) => {
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const userName = getToken("employeeName");
  const userID = getToken("Id");
  const [approveRejectWithdrawRegularization] =
    useSetRegularizationUpdateMutation();
  const [getDashBoardReviewsData] = useLazyGetDashBoardReviewsQuery({});
  const { employeesList } = useSelector((state) => state.notification);
  const { isReviewRegularizationScreen } = useSelector(
    (state) => state.regularization
  );

  const getStatusData = () => {
    switch (data.status) {
      case "APPROVED":
        return {
          style: "font-medium text-green-500",
          displayMessage: `Regularized by: ${getEmployeeName("approvedBy")}`,
        };
      case "PENDING":
        return {
          style: "font-medium text-grey-500",
          displayMessage: `Pending with: ${
            isReviewRegularizationScreen
              ? userName
              : getEmployeeName("appliedTo")
          }`,
        };
      case "REJECTED":
        return {
          style: "font-medium text-red-500",
          displayMessage: `Rejected by: ${getEmployeeName("rejectedBy")}`,
        };
      case "WITHDRAWAL":
        return {
          style: "font-medium text-grey-500",
          displayMessage: "CANCELLED",
        };
      default:
        return {
          style: "font-medium text-grey-500",
          displayMessage: "-",
        };
    }
  };

  const getEmployeeName = (param) => {
    const name = employeesList.find((each) => each.id === data[param]);
    return name?.name || "Admin";
  };
  const DetailsVisibility = () => {
    setIsDetailsVisible(!isDetailsVisible);
  };
  const handleClickOpen = () => {
    setIsDialogOpen((prev) => !prev);
  };
  const handleClose = () => {
    setIsDialogOpen((prev) => !prev);
  };
  const handleRegularization = async (regularizationId, body, message)=>{
    try{
      isReviewCard && getDashBoardReviewsData()
      await approveRejectWithdrawRegularization({
        regularizationId: regularizationId,
        body: body,
      }).unwrap();
      toast.success(`Regularization ${message} successfully`);
    }catch(error) {
      console.error(error)
      toast.error('Failed to Update Regularization')
    }
  }
  const handleApprove = () => {
    let body = JSON.parse(JSON.stringify(data));
    body.status = "APPROVED";
    body.approvedBy = userID;
    const regularizationId = data.id;
    handleRegularization(regularizationId, body, 'approved')
    handleClose();
  };
  const handleReject = () => {
    let body = JSON.parse(JSON.stringify(data));
    body.status = "REJECTED";
    body.rejectedBy = userID;
    body.rejectionReason = rejectReason;
    const regularizationId = data.id;
    handleRegularization(regularizationId, body, 'rejected')
    handleClose();
  };
  const handleWithdraw = () => {
    let body = JSON.parse(JSON.stringify(data));
    body.status = "WITHDRAWAL";
    const regularizationId = data.id;
    handleRegularization(regularizationId, body, 'withdrawed')
  };
  const changeDateFormat = () => {
    const date = new Date(data.createdDate);
    const changedDate = dayjs(date).format("DD-MMM YYYY");
    return changedDate;
  };
  const datesApplied = () => {
    let datesApplied = "";
    let monthYear;
    data.entries.map((each) => {
      const date = new Date(each.date);
      const day = dayjs(date).format("DD");
      monthYear = dayjs(date).format("MMM YYYY");
      datesApplied = datesApplied + day + ",";
    });
    return `${datesApplied + " " + monthYear}`;
  };
  return (
    <div className="my-3 bg-white border border-gray-300 rounded-md font-medium shadow-md">
      <Dialog open={isDialogOpen} onClose={handleClose} maxWidth="xl" fullWidth>
        <DialogContent>
          <FullDetailsRegularization
            data={data}
            getStatusData={getStatusData}
            getEmployeeName={getEmployeeName}
          />
        </DialogContent>
        <DialogActions className={`my-2 m-5 !flex !justify-between`}>
          {isReviewRegularizationScreen && shouldShowApplyRejectButtons && (
            <div className="flex items-center">
              <TextField
                label="Reject Reason"
                name="rejectReason"
                variant="outlined"
                onChange={(e) => setRejectReason(e.target.value)}
                value={rejectReason}
                sx={{
                  "& .MuiInputBase-root": {
                    height: 50,
                  },
                }}
              />
              <p className="text-red-500 font-medium ml-5">Note: Enter Reject Reason to Reject Regularization.</p>
            </div>
          )}
          <div>
            {isReviewRegularizationScreen && shouldShowApplyRejectButtons && (
              <>
                <Button
                  onClick={handleApprove}
                  disabled={rejectReason}
                  color="success"
                >
                  Approve
                </Button>{" "}
                <Button
                  onClick={handleReject}
                  disabled={!rejectReason}
                  color="error"
                >
                  Reject
                </Button>
              </>
            )}
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </div>
        </DialogActions>
      </Dialog>
      <div className="flex w-full gap-5 justify-between p-3">
        <p className="w-[33%]">
          {isReviewRegularizationScreen
            ? getEmployeeName("employeeId")
            : getStatusData()?.displayMessage}
        </p>
        <p className="w-[33%]">No.of days {data?.entries.length}</p>
        <div className="flex gap-3 w-[33%] justify-end">
          <p className={`${getStatusData().style}`}>{data.status}</p>
          {isDetailsVisible ? (
            <ChevronDoubleUpIcon
              className="h-7 text-black cursor-pointer"
              onClick={DetailsVisibility}
            />
          ) : (
            <ChevronDoubleDownIcon
              className="h-7 text-black cursor-pointer"
              onClick={DetailsVisibility}
            />
          )}
        </div>
      </div>
      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          isDetailsVisible ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="border-y-2 p-3">Dates Applied: {datesApplied()}</div>

        <div className="flex w-full justify-between p-3">
          <p>Applied ON: {changeDateFormat()}</p>
          <div className="flex gap-3">
            <p className="cursor-pointer text-xl" onClick={handleClickOpen}>
              View Details
            </p>
            {!isReviewRegularizationScreen && data.status === "PENDING" && (
              <button className="text-xl" onClick={handleWithdraw}>
                {" "}
                Withdraw{" "}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReusableRegularization;
